function NameHeader(props) {
    return (
        <center>
        <h1 style={{color: "white", display: 'inline-block', 'white-space': 'pre'}}>{props.name} </h1>
        <h1 style={{display: 'inline-block'}} className="title">Has A Huge Dick</h1>
        </center>
    )
}

export default NameHeader